import { useMemo } from "react";

import {
    buildClient360Journey,
    buildClient360Opportunities,
    buildClient360Snapshot,
    buildClient360Stats,
    buildClient360Timeline,
} from "../../helpers";
import type { Client360PanelProps } from "./types";

export function useClient360PanelData({
    issues,
    loyaltyCard,
    orders,
    profile,
    traderDefect,
}: Pick<Client360PanelProps, "issues" | "loyaltyCard" | "orders" | "profile" | "traderDefect">) {
    return useMemo(() => ({
        stats: buildClient360Stats(profile, loyaltyCard, orders, issues, traderDefect),
        timeline: buildClient360Timeline(profile, loyaltyCard, orders, issues),
        journey: buildClient360Journey(profile, loyaltyCard, orders, issues),
        opportunities: buildClient360Opportunities(profile, loyaltyCard, orders, issues),
        snapshot: buildClient360Snapshot(profile, loyaltyCard, orders, issues),
    }), [issues, loyaltyCard, orders, profile, traderDefect]);
}
